/**
 * места в книге, к которым ведут ссылки наблюдателя. id постоянный и общий
 * для всех языков; текст — фраза, которую экран метода ищет в главе на
 * языке книги. null — места в переводе нет, ссылка открывает главу с начала.
 */
export const BOOK_ANCHORS = {
    'pan-vhod': { ru: 'Вход. Пан.', en: 'Entry. Pan.' },
    'aid-pogruzhenie': { ru: 'Погружение. Аид.', en: 'Descent. Hades.' },
    'dionis-ekstaz': { ru: 'Это Дионис — бог экстаза', en: 'This is Dionysus, the god of ecstasy' },
    'shest-personazhey': { ru: 'целых шесть персонажей', en: 'no fewer than six characters' },
};
export function isAnchorId(v) {
    return typeof v === 'string' && Object.hasOwn(BOOK_ANCHORS, v);
}
/** старые наблюдения хранят только русскую фразу: по ней находится id */
export function anchorIdByPhrase(phrase) {
    for (const [id, t] of Object.entries(BOOK_ANCHORS))
        if (t.ru === phrase)
            return id;
    return null;
}
/**
 * фраза для прокрутки в книге на этом языке. ссылка с id берет фразу из
 * реестра, старая ссылка без id — свою русскую фразу, если книга русская
 */
export function anchorPhrase(ref, locale) {
    const id = isAnchorId(ref.anchorId) ? ref.anchorId : ref.anchor ? anchorIdByPhrase(ref.anchor) : null;
    if (id)
        return BOOK_ANCHORS[id][locale] ?? undefined;
    return locale === 'ru' ? ref.anchor : undefined;
}
//# sourceMappingURL=book-anchors.js.map